<div class="bg-side-bar-geia main-menu menu-fixed menu-dark menu-accordion menu-shadow" data-scroll-to-active="true">
  <div class="bg-side-bar-geia main-menu-content">
    <span></span>
    <ul style="opacity: 1" class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
      <!-- *ngIf="isShowMenu" -->
      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-item">
        <a [routerLink]="'/dashboard'">
          <i class="icon-home"></i>
          <span class="menu-title" data-i18n="nav.dash.main">Home</span>
        </a>
      </li>



      <li *ngFor="let itemModulos of listaModulos" class="nav-item has-sub">
        <a>
          <i [ngClass]="itemModulos.Icon"></i>
          <span class="menu-title">{{ itemModulos.moduleName }}</span>
        </a>
        <ul class="menu-content">
          <ng-container *ngFor="let itemSubmodulos of itemModulos.subModules">
            <!-- *ngIf="itemSubmodulos.prod ? isShowMenuProd : isShowMenu" -->
            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <a
                class="menu-item"
                [routerLink]="itemSubmodulos.Entity"
                (click)="itemSubmodulos.subModuleName === 'Contratos' ? onClickContrato() : null">
                {{ itemSubmodulos.subModuleName }}
              </a>
            </li>
          </ng-container>
        </ul>
      </li>

      <!-- Suporte -->
      <li *ngIf="isShowMenu" class="navigation-header">
        <span data-i18n="nav.category.support">Suporte</span>
        <i
          class="ft-more-horizontal ft-minus"
          data-toggle="tooltip"
          data-placement="right"
          data-original-title="Support"></i>
      </li>
      <li *ngIf="isShowMenu" class="nav-item">
        <a>
          <i class="icon-support"></i>
          <span class="menu-title" data-i18n="nav.support_raise_support.main">TI</span>
        </a>
      </li>
      <li *ngIf="isShowMenu" class="nav-item">
        <a>
          <i class="icon-support"></i>
          <span class="menu-title" data-i18n="nav.support_raise_support.main">Desenvolvimento</span>
        </a>
      </li>
      <li *ngIf="isShowMenu" class="nav-item">
        <a target="_blank" href="https://pixinvent.com/robust-bootstrap-admin-template/documentation">
          <i class="icon-notebook"></i>
          <span class="menu-title" data-i18n="nav.support_documentation.main">Documentação</span>
        </a>
      </li>
      <hr />


    </ul>
  </div>
</div>
